import type { ContinueWatchingDtoContinueWatchingPageView } from '@bldsoft/cappie/api/wbs'
import type { IContinueWatching } from './index.h'

import {
  getBackgroundImage,
  getHorizontalImage,
  getVerticalImage,
} from '../../utils/images'
import { formatDuration } from '../../utils/media'

export const formatContinueWatching = ({
  content,
}: {
  content: readonly ContinueWatchingDtoContinueWatchingPageView[]
}): Array<IContinueWatching> => {
  return content.map(formatContinueWatchingItem)
}

export const formatContinueWatchingItem = (contentItem: IContinueWatching) => ({
  ...contentItem,
  duration: formatDuration({ length: contentItem.length }),
  landscapeImageUrl: getHorizontalImage(contentItem.landscapeImageUrl),
  portraitImageUrl: getVerticalImage(contentItem.portraitImageUrl),
  backgroundImageUrl: getBackgroundImage(contentItem.backgroundImageUrl),
})
